<div class="!p-0 h-full">
  <router-outlet />
</div>
